import { ALTERAR_REGISTROS_POR_PAGINA_MAPAS_VEICULOS } from '../types'

export default function alterarRegistrosPorPaginaMapasVeiculos (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_MAPAS_VEICULOS,
    payload: valor
  }
}
